module.exports = __webpack_public_path__ + "img/asset_management_system.f1d7d39f.jpg";